module.exports = __webpack_public_path__ + "img/user-o.6e34c8c8.png";